module.exports = __webpack_public_path__ + "img/9788982739798.647f2b47.jpg";